const translations = {
  en: {
    nav: {
      home: 'Home',
      inventory: 'Inventory',
      about: 'About',
      contact: 'Contact',
      favorites: 'My Favorites',
      admin: 'Admin Panel',
      login: 'Login',
      logout: 'Logout',
      compare: 'Compare',
      darkMode: 'Dark Mode',
      lightMode: 'Light Mode',
      language: 'Language'
    },
    notifications: {
      title: 'Notifications',
      markAllRead: 'Mark all as read',
      noNotifications: 'No notifications yet',
      justNow: 'Just now',
      minAgo: 'min ago',
      hoursAgo: 'hours ago',
      yesterday: 'Yesterday',
      daysAgo: 'days ago'
    },
    hero: {
      title: 'Find Your Dream Car',
      subtitle: 'Premium Selection of 350+ Luxury & Performance Vehicles',
      search: 'Search vehicles...',
      browse: 'Browse Inventory',
      newArrivals: 'New Arrivals',
      viewLatest: 'View Latest Vehicles',
      trustedBy: 'Trusted by Thousands',
      yearsExperience: 'Years Experience',
      happyCustomers: 'Happy Customers',
      vehiclesSold: 'Vehicles Sold',
      featuredVehicles: 'Featured Vehicles',
      handpickedPremium: 'Handpicked premium vehicles from our collection',
      noFeaturedAvailable: 'No featured vehicles available at the moment.',
      viewAllVehicles: 'View All Vehicles',
      whyChoose: 'Why Choose AAA Of Miami',
      trustedPartner: 'Your trusted partner in luxury automotive excellence',
      premiumSelection: 'Premium Selection',
      premiumSelectionDesc: 'Over 350 carefully curated luxury and performance vehicles',
      expertService: 'Expert Service',
      expertServiceDesc: 'Dedicated team with years of automotive expertise',
      trustedQuality: 'Trusted Quality',
      trustedQualityDesc: 'Every vehicle thoroughly inspected and certified',
      readyToFind: 'Ready to Find Your Perfect Vehicle?',
      visitShowroom: 'Visit our showroom or browse our complete inventory online',
      contactUs: 'Contact Us',
      browseInventoryCTA: 'Browse Inventory',
      contactUsCTA: 'Contact Us',
      whatCustomersSay: 'What our customers say about us',
      viewAllReviews: 'View All Reviews'
    },
    google: {
      rateUs: 'Rate Us on Google',
      rateUsDesc: 'Share your experience and help other customers make the right choice',
      writeReview: 'Write a Google Review',
      viewOnMaps: 'View on Google Maps',
      basedOnReviews: '150+ reviews'
    },
    filters: {
      title: 'Filters',
      brand: 'Brand',
      model: 'Model',
      yearFrom: 'Year From',
      yearTo: 'Year To',
      yearRange: 'Year',
      priceFrom: 'Price From',
      priceTo: 'Price To',
      priceRange: 'Price',
      maxMileage: 'Max Mileage',
      transmission: 'Transmission',
      fuelType: 'Fuel Type',
      search: 'Search',
      reset: 'Reset',
      resetAll: 'Reset All',
      applyFilters: 'Apply Filters',
      allBrands: 'All Brands',
      vehiclesFound: 'vehicles found',
      miles: 'miles',
      more: 'more',
      allVehiclesShown: 'All vehicles shown',
      total: 'total'
    },
    vehicle: {
      mileage: 'miles',
      year: 'Year',
      price: 'Price',
      transmission: 'Transmission',
      fuelType: 'Fuel Type',
      engine: 'Engine',
      color: 'Color',
      vin: 'VIN',
      features: 'Features',
      description: 'Description',
      requestQuote: 'Request Quote',
      scheduleTest: 'Schedule Test Drive',
      addToFavorites: 'Add to Favorites',
      removeFromFavorites: 'Remove from Favorites',
      compare: 'Compare',
      viewDetails: 'View Details',
      featured: 'Featured',
      contactWhatsApp: 'Contact via WhatsApp',
      shareWhatsApp: 'Share via WhatsApp',
      whatsAppMessage: 'Hi, I am interested in the'
    },
    finance: {
      calculator: 'Finance Calculator',
      vehiclePrice: 'Vehicle Price',
      downPayment: 'Down Payment',
      interestRate: 'Interest Rate (%)',
      loanTerm: 'Loan Term (months)',
      monthlyPayment: 'Estimated Monthly Payment',
      calculate: 'Calculate'
    },
    contact: {
      title: 'Contact Us',
      contactMessage: 'Contact Message',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      subject: 'Subject',
      message: 'Message',
      send: 'Send Message',
      success: 'Message sent successfully!',
      error: 'Failed to send message. Please try again.',
      whatsapp: 'WhatsApp Contact',
      whatsappDesc: 'Get instant responses! Chat with us directly on WhatsApp.',
      chatWhatsapp: 'Chat on WhatsApp',
      whatsappDefaultMessage: 'Hello! I would like to get more information about your vehicles.'
    },
    testDrive: {
      title: 'Schedule Test Drive',
      preferredDate: 'Preferred Date',
      preferredTime: 'Preferred Time',
      submit: 'Submit Request',
      success: 'Test drive request submitted!',
      error: 'Failed to submit request'
    },
    quote: {
      title: 'Request Price Quote',
      submit: 'Request Quote',
      offeredPrice: 'Your Offered Price ($)',
      success: 'Quote request submitted!',
      error: 'Failed to submit request'
    },
    admin: {
      dashboard: 'Dashboard',
      success: 'Success',
      error: 'Error',
      pleaseLogin: 'Please login first',
      syncError: 'Sync error',
      unknownError: 'Unknown error',
      syncTimeout: 'Timeout: Sync may still be running. Please refresh the page in a few minutes.',
      syncFailed: 'eBay sync failed',
      pleaseWriteReply: 'Please write a reply',
      vehicles: 'Vehicles',
      addVehicle: 'Add Vehicle',
      editVehicle: 'Edit Vehicle',
      testDrives: 'Test Drive Requests',
      quotes: 'Quote Requests',
      messages: 'Contact Messages',
      reviews: 'Reviews',
      stats: 'Statistics',
      totalVehicles: 'Total Vehicles',
      pendingRequests: 'Pending Requests',
      newMessages: 'New Messages',
      adminPanel: 'Admin Panel',
      status: 'Status',
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
      completed: 'Completed',
      approve: 'Approve',
      reject: 'Reject',
      reply: 'Reply',
      viewDetails: 'View Details',
      customerName: 'Customer Name',
      customerEmail: 'Email',
      customerPhone: 'Phone',
      preferredDate: 'Preferred Date',
      preferredTime: 'Preferred Time',
      requestDate: 'Request Date',
      actions: 'Actions',
      noRequests: 'No requests found',
      sendReply: 'Send Reply',
      replyMessage: 'Reply Message',
      typeReply: 'Type your reply here...',
      replySent: 'Reply sent successfully',
      replyFailed: 'Failed to send reply',
      statusUpdated: 'Status updated successfully',
      statusUpdateFailed: 'Failed to update status',
      subject: 'Subject',
      message: 'Message',
      totalInventoryValue: 'Total Inventory Value',
      replied: 'Replied',
      // Admin Panel - Vehicle Management
      available: 'Available',
      sold: 'Sold',
      soldVehicles: 'sold vehicles',
      downloading: 'Downloading...',
      excel: 'Excel',
      filter: 'Filter',
      advancedFilters: 'Advanced Filters',
      clear: 'Clear',
      statusLabel: 'Status',
      brandLabel: 'Brand',
      minPrice: 'Min Price',
      maxPrice: 'Max Price',
      minYear: 'Min Year',
      maxYear: 'Max Year',
      showDuplicateVins: 'Show Duplicate VINs',
      allItems: 'All',
      vehiclesSelected: 'vehicles selected',
      markAvailable: 'Mark Available',
      markSold: 'Mark Sold',
      featureVehicle: 'Feature',
      cancel: 'Cancel',
      reactivate: 'Reactivate',
      syncCompleted: 'Sync Completed!',
      syncNewAdded: 'new vehicles added',
      syncMarkedSold: 'vehicles marked as sold',
      syncVinConflicts: 'VIN conflicts (review needed)',
      syncUnchanged: 'vehicles unchanged',
      syncTotalEbay: 'Total eBay listings',
      syncCompletedUnclear: 'Sync completed but result unclear',
      syncTimeoutMessage: 'Timeout: Sync may still be running. Refresh in a few minutes.',
      addAll: 'Add All',
      searchByVin: 'Search by VIN...',
      resultsFound: 'results found',
      newBadge: 'NEW',
      reactivateTitle: 'Reactivate',
      markAsSoldTitle: 'Mark as Sold',
      selectAll: 'Select All',
      vehicleCount: 'vehicles',
      vinConflictsTitle: 'VIN Conflicts',
      allSynced: 'All vehicles have been synced correctly.',
      refresh: 'Refresh',
      vinConflictWarning: 'These vehicles share the same VIN but have different make/model/year. The VIN was likely reused for a different listing on eBay. Review each conflict and decide.',
      newListing: 'New Listing',
      addAsNewVehicle: 'Add as New Vehicle',
      skipConflict: 'Skip',
      existingVehicle: 'Existing Vehicle',
      vinConflictsNote: 'Note:',
      // Price Quote Actions
      approveQuote: 'Approve',
      rejectQuote: 'Reject',
      approve: 'Approve',
      reject: 'Reject',
      reply: 'Reply',
      quoteApproved: 'Quote approved! Customer notified.',
      quoteRejected: 'Quote rejected! Customer notified.',
      operationFailed: 'Operation failed',
      replySentSuccess: 'Reply sent! Email and notification delivered.',
      priceQuoteResponse: 'Price Quote Response',
      offeredPrice: 'Offered Price',
      replyWillBeSent: 'Your reply will be sent to customer via email and notification.',
      vehicleReactivated: 'Vehicle reactivated!',
      vehicleMarkedSold: 'Vehicle marked as sold!',
      makeAvailable: 'Mark Available',
      markAsSold: 'Mark as Sold',
      syncing: 'Syncing...',
      syncFromEbay: 'Sync from eBay',
      all: 'All',
      brand: 'Brand',
      overview: 'Overview',
      pendingTestDrives: 'Pending Test Drives',
      pendingQuotes: 'Pending Quotes',
      monthlyActivity: 'Monthly Activity',
      requestStatusDistribution: 'Request Status Distribution',
      trendAnalysis: '6-Month Trend Analysis',
      manageVehicles: 'Manage Vehicles',
      totalActiveVehicles: 'active vehicles',
      searchVehicles: 'Search by brand, model, year, or price...',
      vehicle: 'Vehicle',
      price: 'Price',
      year: 'Year',
      mileage: 'Mileage',
      featured: 'Featured',
      addVehicleBtn: 'Add Vehicle',
      updateVehicle: 'Update Vehicle',
      deleteVehicle: 'Delete Vehicle',
      confirmDelete: 'Are you sure you want to delete',
      cannotUndo: 'This action cannot be undone.',
      brand: 'Brand',
      model: 'Model',
      color: 'Color',
      vin: 'VIN',
      engine: 'Engine',
      transmission: 'Transmission',
      fuelType: 'Fuel Type',
      description: 'Description',
      features: 'Features (comma-separated)',
      vehicleImages: 'Vehicle Images',
      uploadFromComputer: 'Upload from Computer',
      uploading: 'Uploading images...',
      uploadedImages: 'Uploaded Images:',
      orEnterUrls: 'Or Enter Image URLs (comma-separated)',
      featuredVehicle: 'Featured Vehicle',
      rating: 'Rating',
      review: 'Review',
      noReviewsFound: 'No reviews found',
      reviewType: 'Review Type',
      vehicleReviewType: 'Vehicle',
      generalReviewType: 'General',
      serviceReviewType: 'Service',
      dealershipReviewType: 'Dealership',
      allReviews: 'All Reviews',
      testDrivesLabel: 'Test Drives',
      priceQuotesLabel: 'Price Quotes',
      messagesLabel: 'Messages',
      reviewsLabel: 'Reviews',
      campaignsLabel: 'Campaigns',
      analyticsLabel: 'Analytics',
      performanceLabel: 'Performance',
      usersLabel: 'Users',
      scrollToSee: 'Scroll to see all columns',
      dragToReorder: 'Drag to reorder (first image = main)',
      suspiciousPhotosTab: 'Suspicious Photos',
      suspiciousPhotosTitle: 'Suspicious Photos (AI Scan)',
      suspiciousPhotosSub: 'AI scans every vehicle photo for banners, ads, and wrong-vehicle images.',
      startAIScan: 'Start AI Scan',
      aiScanInProgress: 'AI scan in progress',
      scanStarted: 'AI photo scan started',
      scanFinished: 'Scan finished',
      photosFlagged: 'photos flagged',
      photosScanned: 'photos scanned',
      flagged: 'flagged',
      highSeverity: 'High',
      mediumSeverity: 'Medium',
      all: 'All',
      remove: 'Remove',
      keep: 'Keep',
      viewVehicle: 'View vehicle',
      photoRemoved: 'Photo removed',
      photoKept: 'Photo kept',
      noSuspiciousPhotos: 'No suspicious photos found. Run a scan to check.',
      vinConflictHeading: 'This VIN is also used in another active listing.',
      vinConflictShort: 'Add the new one as a separate record?',
      vinConflictSameCar: 'This vehicle is already listed. Do you want to add it again?',
      vinConflictDifferentCar: 'These two vehicles share the same VIN but the year/mileage differ — they are not the same car.',
      addAllDifferent: 'Add Different Cars',
      addAllDifferentTooltip: 'Add every conflict where the cars are clearly different despite sharing a VIN',
      noDifferentCars: 'No "different car" conflicts to add',
      vinConflictBody: 'The new listing below has the same VIN as a vehicle already published on your site. Do you want to add this new listing? "Add" creates a second separate record (both listings will be visible). "Skip" ignores the new listing. Either choice keeps your existing listing untouched.',
      enhance: 'AI Photo',
      enhanceAllPhotos: 'Move Photos to Showroom',
      enhanceAllTooltip: 'Replace all vehicle photo backgrounds with AAA OF MIAMI showroom (AI)',
      enhancePhotosTooltip: 'Move this vehicle\'s photos into the showroom background (AI)',
      enhancingPhotos: 'Processing photos...',
      photosEnhanced: 'photos enhanced',
      processing: 'Processing...',
      restore: 'Restore',
      restoreOriginalsTooltip: 'Restore original photos',
      originalsRestored: 'Original photos restored',
      batchEnhanceStarted: 'Batch photo enhancement started. Running in background.',
      batchEnhanceProgress: 'Photo enhancement in progress',
      vehiclesProcessed: 'vehicles processed',
      sendReply: 'Send Reply',
      cancel: 'Cancel',
      totalInquiries: 'Total Inquiries',
      vehiclesSold: 'Vehicles Sold',
      completedRequests: 'Completed',
      vehiclesUnit: 'vehicles',
      analytics: 'Analytics',
      totalVisits: 'Total Visits',
      uniqueVisitors: 'Unique Visitors',
      todayVisits: "Today's Visits",
      avgPageViews: 'Avg. Page Views',
      trafficSources: 'Traffic Sources',
      direct: 'Direct',
      google: 'Google',
      socialMedia: 'Social Media',
      other: 'Other',
      popularPages: 'Most Popular Pages',
      visits: 'Visits',
      weeklyTrend: '7-Day Trend',
      dailyVisits: 'Daily Visits',
      detailedReferrers: 'Detailed Traffic Sources',
      referrer: 'Source',
      users: 'Users',
      members: 'Members',
      totalMembers: 'Total Members',
      adminUsers: 'Admin Users',
      regularUsers: 'Regular Users',
      last7Days: 'Last 7 Days',
      searchPlaceholder: 'Search by email or username...',
      username: 'Username',
      email: 'Email',
      role: 'Role',
      registrationDate: 'Registration Date',
      noUsersFound: 'No users found',
      admin: 'Admin',
      user: 'User',
      removeAdmin: 'Remove Admin',
      makeAdmin: 'Make Admin',
      deleteUser: 'Delete User',
      deleteUserConfirm: 'Are you sure you want to delete',
      deleteUserWarning: 'This action cannot be undone.',
      cancel: 'Cancel',
      yesDelete: 'Yes, Delete',
      userDeletedSuccess: 'User deleted successfully',
      userDeleteFailed: 'Failed to delete user',
      adminGranted: 'User granted admin privileges',
      adminRevoked: 'Admin privileges revoked',
      operationFailed: 'Operation failed',
      usersLoadFailed: 'Failed to load users',
      loading: 'Loading...',
      emailMarketing: 'Email Marketing',
      emailCampaigns: 'Email Campaigns',
      priceDropAlert: 'Price Drop Alert',
      newCampaign: 'New Campaign',
      manageCampaigns: 'Manage campaigns and send promotional emails',
      totalCampaigns: 'Total Campaigns',
      sentCampaigns: 'Sent',
      totalUsers: 'Total Users',
      optedInUsers: 'Opted In',
      sendPriceDropAlert: 'Send Price Drop Alert',
      selectVehicle: 'Select Vehicle',
      chooseVehicle: 'Choose a vehicle',
      oldPrice: 'Old Price',
      currentPrice: 'Current price',
      newPrice: 'New Price',
      discountedPrice: 'Discounted price',
      discount: 'Discount',
      saveAmount: 'Save',
      sendToAllUsers: 'Send to All Users',
      createEmailCampaign: 'Create Email Campaign',
      campaignTitle: 'Campaign Title',
      internalCampaignName: 'Internal name for this campaign',
      emailSubject: 'Email Subject',
      inboxSubject: 'What users will see in their inbox',
      emailMessage: 'Message',
      emailContent: 'Email content (supports HTML)',
      campaignType: 'Campaign Type',
      general: 'General',
      promotional: 'Promotional',
      newsletter: 'Newsletter',
      targetAudience: 'Target Audience',
      allUsers: 'All Users',
      optedInOnly: 'Opted In Only',
      createCampaign: 'Create Campaign',
      noCampaignsYet: 'No campaigns yet. Create your first campaign!',
      sent: 'Sent',
      draft: 'Draft',
      sentToUsers: 'Sent to {count} users on {date}',
      sendNow: 'Send Now',
      sending: 'Sending...',
      priceDropHistory: 'Price Drop Alert History',
      noPriceDropAlerts: 'No price drop alerts sent yet',
      campaignSentSuccess: 'Campaign sent to {count} users!',
      priceDropSentSuccess: 'Price drop campaign sent to {count} users!',
      campaignCreatedSuccess: 'Campaign created successfully!',
      failedToLoad: 'Failed to load email campaign data',
      failedToSend: 'Failed to send campaign',
      failedToCreate: 'Failed to create campaign',
      vehicleId: 'Vehicle ID',
      usersCount: 'users'
    },
    perf: {
      title: 'Performance Dashboard',
      subtitle: 'Key metrics and insights about your dealership',
      loadFailed: 'Failed to load statistics',
      noData: 'No data available',
      exportExcel: 'Export Excel',
      exporting: 'Exporting...',
      totalVehicles: 'Total Vehicles',
      available: 'Available',
      sold: 'Sold',
      totalSoldValue: 'Total Sold Value',
      avgPrice: 'Average Price',
      customerEngagement: 'Customer Engagement',
      testDriveRequests: 'Test Drive Requests',
      pendingTestDrives: 'Pending Test Drives',
      priceQuotes: 'Price Quote Requests',
      pendingQuotes: 'Pending Quotes',
      pricingStats: 'Pricing Statistics',
      minPrice: 'Minimum Price',
      maxPrice: 'Maximum Price',
      featuredVehicles: 'Featured Vehicles',
      mostViewed: 'Most Viewed Vehicles',
      mostFavorited: 'Most Favorited Vehicles'
    },
    common: {
      loading: 'Loading...',
      loadMore: 'Load More',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      close: 'Close',
      yes: 'Yes',
      no: 'No',
      confirm: 'Confirm',
      backToInventory: 'Back to Inventory',
      noVehicles: 'No vehicles to compare',
      addVehicles: 'Add vehicles from the inventory to compare them',
      browseInventory: 'Browse Inventory',
      clearAll: 'Clear All',
      compareTitle: 'Compare Vehicles',
      compareSub: 'Compare up to 3 vehicles side by side',
      noFavorites: 'No favorite vehicles yet',
      sendMessage: 'Send us a message',
      visitUs: 'Visit Us',
      address: 'Address',
      businessHours: 'Business Hours',
      getTouchTeam: 'Get in touch with our team',
      yourSavedVehicles: 'Your saved vehicles',
      vehicleNotFound: 'Vehicle not found',
      backToInventoryBtn: 'Back to Inventory',
      all: 'All',
      jan: 'Jan',
      feb: 'Feb',
      mar: 'Mar',
      apr: 'Apr',
      may: 'May',
      jun: 'Jun',
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      june: 'June'
    },
    compare: {
      removedFromComparison: 'Removed from comparison',
      comparisonCleared: 'Comparison cleared'
    },
    compareBar: {
      compareNow: 'Compare Now'
    },
    favorites: {
      noFavorites: 'No favorite vehicles yet',
      browseInventory: 'Browse Inventory'
    },
    vehicleDetail: {
      loginToFavorite: 'Please login to add favorites',
      removedFromFavorites: 'Removed from favorites',
      addedToFavorites: 'Added to favorites',
      failedToUpdate: 'Failed to update favorites',
      maxThreeVehicles: 'You can only compare up to 3 vehicles',
      alreadyInComparison: 'Vehicle already in comparison list',
      addedToComparison: 'Added to comparison'
    },
    contactPage: {
      sending: 'Sending...',
      mondayFriday: 'Monday - Friday',
      mondayFridayHours: '9:00 AM - 7:00 PM',
      saturday: 'Saturday',
      saturdayHours: '10:00 AM - 6:00 PM',
      sunday: 'Sunday',
      sundayHours: '11:00 AM - 5:00 PM'
    },
    reviews: {
      title: 'Customer Reviews',
      writeReview: 'Write a Review',
      yourName: 'Your Name',
      yourEmail: 'Your Email',
      yourRating: 'Your Rating',
      yourReview: 'Your Review',
      submitReview: 'Submit Review',
      reviewSubmitted: 'Review submitted! It will appear after approval.',
      reviewFailed: 'Failed to submit review',
      noReviews: 'No reviews yet',
      beFirst: 'Be the first to review this vehicle!',
      stars: 'stars',
      generalReview: 'General Review',
      writeGeneralReview: 'Write a General Review',
      aboutOurService: 'Share your experience with our dealership',
      generalReviewSubmitted: 'Thank you for your feedback!',
      reviewType: 'Review Type',
      vehicleReview: 'Vehicle Review',
      serviceReview: 'Service & Experience',
      dealershipReview: 'Dealership Review'
    },
    login: {
      title: 'Welcome to AAA OF MIAMI',
      subtitle: 'Sign in to save favorites and manage your requests',
      signIn: 'Sign In',
      signUp: 'Sign Up',
      username: 'Username',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      enterUsername: 'Enter your username',
      enterEmail: 'your@email.com',
      enterPassword: 'Enter your password',
      minChars: 'Minimum 6 characters',
      reenterPassword: 'Re-enter your password',
      signingIn: 'Signing in...',
      creatingAccount: 'Creating account...',
      createAccount: 'Create Account',
      continueAsGuest: 'Continue as Guest',
      memberBenefits: 'Member Benefits:',
      saveFavorites: 'Save your favorite vehicles',
      compareVehicles: 'Compare vehicles side by side',
      forgotPassword: 'Forgot Password?'
    },
    profile: {
      myProfile: 'My Profile',
      username: 'Username',
      email: 'Email',
      membershipType: 'Membership Type',
      admin: 'Admin',
      standardUser: 'Standard User',
      changePassword: 'Change Password',
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      confirmNewPassword: 'Confirm New Password',
      enterCurrentPassword: 'Enter your current password',
      enterNewPassword: 'Enter your new password',
      reenterNewPassword: 'Re-enter your new password',
      passwordChanged: 'Password changed successfully!',
      passwordChangeFailed: 'Failed to change password',
      passwordsDoNotMatch: 'New passwords do not match',
      passwordTooShort: 'New password must be at least 6 characters',
      cancel: 'Cancel',
      logout: 'Logout',
      changing: 'Changing...',
      changePasswordButton: 'Change Password'
    },
    messages: {
      myMessages: 'My Messages',
      noMessages: 'No messages yet',
      sendMessage: 'Send Message',
      messageSent: 'Message sent! You can track it in "My Messages" section.',
      messageFailed: 'Failed to send message',
      loadError: 'Error loading messages',
      pleaseWriteMessage: 'Please write a message',
      replyLabel: 'Reply:',
      send: 'Send',
      sending: 'Sending...',
      sendToSeller: 'Message Seller',
      messageFailedRetry: 'Failed to send message. Please try again.',
      yourInitialMessage: 'Your Initial Message:',
      you: 'You',
      messageSeller: 'Message Seller',
      writeYourMessage: 'Write your message here...',
      writeYourReply: 'Write your reply to the customer...',
      loginRequired: 'You need to login to send a message'
    },
    forgotPassword: {
      title: 'Forgot Password',
      subtitle: 'Enter your email address, we\'ll send you a password reset link',
      emailPlaceholder: 'Your email address',
      sendResetLink: 'Send Reset Link',
      sending: 'Sending...',
      linkSent: 'If the email exists, a reset link has been sent',
      checkEmail: 'Please check your email inbox.',
      backToLogin: 'Back to Login',
      resetSuccess: 'Password reset link sent to your email'
    },
    resetPassword: {
      title: 'Set New Password',
      subtitle: 'Enter your new password',
      newPassword: 'New password',
      confirmPassword: 'Confirm new password',
      changePassword: 'Change Password',
      changing: 'Changing...',
      passwordChanged: 'Password changed successfully!',
      invalidLink: 'Invalid Link',
      linkExpired: 'Password reset link is invalid or expired'
    },
    adminLogin: {
      title: 'ADMIN PANEL',
      subtitle: 'AAA OF MIAMI LLC',
      restrictedAccess: 'Restricted Access Only',
      description: 'Administrator Login',
      enterCredentials: 'Enter your credentials to access the admin panel',
      adminUsername: 'Admin Username',
      enterAdminUsername: 'Enter admin username',
      adminPassword: 'Admin Password',
      enterAdminPassword: 'Enter admin password',
      authenticating: 'Authenticating...',
      accessPanel: 'Access Admin Panel',
      needAccess: 'Need admin access?',
      registerAdmin: 'Register Admin Account',
      backToSite: 'Back to Main Site',
      secureConnection: 'Secure SSL connection',
      firstUserAdmin: 'First registered user becomes admin automatically',
      warning: 'This area is restricted to authorized administrators only. Unauthorized access attempts are logged.'
    }
  },
  es: {
    nav: {
      home: 'Inicio',
      inventory: 'Inventario',
      about: 'Acerca de',
      contact: 'Contacto',
      favorites: 'Mis Favoritos',
      admin: 'Panel Admin',
      login: 'Iniciar Sesión',
      logout: 'Cerrar Sesión',
      compare: 'Comparar',
      darkMode: 'Modo Oscuro',
      lightMode: 'Modo Claro',
      language: 'Idioma'
    },
    notifications: {
      title: 'Notificaciones',
      markAllRead: 'Marcar todo como leído',
      noNotifications: 'No hay notificaciones',
      justNow: 'Ahora mismo',
      minAgo: 'min atrás',
      hoursAgo: 'horas atrás',
      yesterday: 'Ayer',
      daysAgo: 'días atrás'
    },
    hero: {
      title: 'Encuentra Tu Auto Soñado',
      subtitle: 'Selección Premium de Más de 350 Vehículos de Lujo y Alto Rendimiento',
      search: 'Buscar vehículos...',
      browse: 'Ver Inventario',
      newArrivals: 'Nuevas Llegadas',
      viewLatest: 'Ver Últimos Vehículos',
      trustedBy: 'Confiado por Miles',
      yearsExperience: 'Años de Experiencia',
      happyCustomers: 'Clientes Felices',
      vehiclesSold: 'Vehículos Vendidos',
      featuredVehicles: 'Vehículos Destacados',
      handpickedPremium: 'Vehículos premium seleccionados de nuestra colección',
      noFeaturedAvailable: 'No hay vehículos destacados disponibles en este momento.',
      viewAllVehicles: 'Ver Todos los Vehículos',
      whyChoose: 'Por Qué Elegir AAA Of Miami',
      trustedPartner: 'Tu socio de confianza en excelencia automotriz de lujo',
      premiumSelection: 'Selección Premium',
      premiumSelectionDesc: 'Más de 350 vehículos de lujo y rendimiento cuidadosamente seleccionados',
      expertService: 'Servicio Experto',
      expertServiceDesc: 'Equipo dedicado con años de experiencia automotriz',
      trustedQuality: 'Calidad Confiable',
      trustedQualityDesc: 'Cada vehículo inspeccionado y certificado a fondo',
      readyToFind: '¿Listo para Encontrar Tu Vehículo Perfecto?',
      visitShowroom: 'Visita nuestro showroom o navega nuestro inventario completo en línea',
      contactUs: 'Contáctanos',
      browseInventoryCTA: 'Ver Inventario',
      contactUsCTA: 'Contáctanos',
      whatCustomersSay: 'Lo que dicen nuestros clientes',
      viewAllReviews: 'Ver Todas las Reseñas'
    },
    google: {
      rateUs: 'Califícanos en Google',
      rateUsDesc: 'Comparte tu experiencia y ayuda a otros clientes a tomar la decisión correcta',
      writeReview: 'Escribe una Reseña en Google',
      viewOnMaps: 'Ver en Google Maps',
      basedOnReviews: 'más de 150 reseñas'
    },
    filters: {
      title: 'Filtros',
      brand: 'Marca',
      model: 'Modelo',
      yearFrom: 'Año Desde',
      yearTo: 'Año Hasta',
      yearRange: 'Año',
      priceFrom: 'Precio Desde',
      priceTo: 'Precio Hasta',
      priceRange: 'Precio',
      maxMileage: 'Kilometraje Máx',
      transmission: 'Transmisión',
      fuelType: 'Tipo de Combustible',
      search: 'Buscar',
      reset: 'Restablecer',
      resetAll: 'Restablecer Todo',
      applyFilters: 'Aplicar Filtros',
      allBrands: 'Todas las Marcas',
      vehiclesFound: 'vehículos encontrados',
      miles: 'millas',
      more: 'más',
      allVehiclesShown: 'Todos los vehículos mostrados',
      total: 'total'
    },
    vehicle: {
      mileage: 'millas',
      year: 'Año',
      price: 'Precio',
      transmission: 'Transmisión',
      fuelType: 'Tipo de Combustible',
      engine: 'Motor',
      color: 'Color',
      vin: 'VIN',
      features: 'Características',
      description: 'Descripción',
      requestQuote: 'Solicitar Cotización',
      scheduleTest: 'Agendar Prueba',
      addToFavorites: 'Agregar a Favoritos',
      removeFromFavorites: 'Quitar de Favoritos',
      compare: 'Comparar',
      viewDetails: 'Ver Detalles',
      featured: 'Destacado',
      contactWhatsApp: 'Contactar por WhatsApp',
      shareWhatsApp: 'Compartir por WhatsApp',
      whatsAppMessage: 'Hola, estoy interesado en el'
    },
    finance: {
      calculator: 'Calculadora de Financiamiento',
      vehiclePrice: 'Precio del Vehículo',
      downPayment: 'Pago Inicial',
      interestRate: 'Tasa de Interés (%)',
      loanTerm: 'Plazo del Préstamo (meses)',
      monthlyPayment: 'Pago Mensual Estimado',
      calculate: 'Calcular'
    },
    contact: {
      title: 'Contáctenos',
      contactMessage: 'Mensaje de Contacto',
      name: 'Nombre',
      email: 'Correo',
      phone: 'Teléfono',
      subject: 'Asunto',
      message: 'Mensaje',
      send: 'Enviar Mensaje',
      success: '¡Mensaje enviado con éxito!',
      error: 'Error al enviar mensaje. Por favor intente de nuevo.',
      whatsapp: 'Contacto WhatsApp',
      whatsappDesc: '¡Obtén respuestas instantáneas! Chatea con nosotros directamente en WhatsApp.',
      chatWhatsapp: 'Chatear en WhatsApp',
      whatsappDefaultMessage: '¡Hola! Me gustaría obtener más información sobre sus vehículos.'
    },
    testDrive: {
      title: 'Agendar Prueba de Manejo',
      preferredDate: 'Fecha Preferida',
      preferredTime: 'Hora Preferida',
      submit: 'Enviar Solicitud',
      success: '¡Solicitud de prueba enviada!',
      error: 'Error al enviar solicitud'
    },
    quote: {
      title: 'Solicitar Cotización',
      submit: 'Solicitar Cotización',
      offeredPrice: 'Tu Precio Ofrecido ($)',
      success: '¡Solicitud de cotización enviada!',
      error: 'Error al enviar solicitud'
    },
    admin: {
      dashboard: 'Panel de Control',
      success: 'Éxito',
      error: 'Error',
      pleaseLogin: 'Por favor inicia sesión primero',
      syncError: 'Error de sincronización',
      unknownError: 'Error desconocido',
      syncTimeout: 'Tiempo agotado: La sincronización puede estar ejecutándose. Por favor actualiza la página en unos minutos.',
      syncFailed: 'Falló la sincronización de eBay',
      pleaseWriteReply: 'Por favor escribe una respuesta',
      vehicles: 'Vehículos',
      addVehicle: 'Agregar Vehículo',
      editVehicle: 'Editar Vehículo',
      testDrives: 'Solicitudes de Prueba',
      quotes: 'Solicitudes de Cotización',
      messages: 'Mensajes de Contacto',
      reviews: 'Comentarios',
      stats: 'Estadísticas',
      totalVehicles: 'Total de Vehículos',
      pendingRequests: 'Solicitudes Pendientes',
      newMessages: 'Mensajes Nuevos',
      adminPanel: 'Panel de Administración',
      status: 'Estado',
      pending: 'Pendiente',
      approved: 'Aprobado',
      rejected: 'Rechazado',
      completed: 'Completado',
      approve: 'Aprobar',
      reject: 'Rechazar',
      reply: 'Responder',
      viewDetails: 'Ver Detalles',
      customerName: 'Nombre del Cliente',
      customerEmail: 'Correo Electrónico',
      customerPhone: 'Teléfono',
      preferredDate: 'Fecha Preferida',
      preferredTime: 'Hora Preferida',
      requestDate: 'Fecha de Solicitud',
      actions: 'Acciones',
      noRequests: 'No se encontraron solicitudes',
      sendReply: 'Enviar Respuesta',
      replyMessage: 'Mensaje de Respuesta',
      typeReply: 'Escribe tu respuesta aquí...',
      replySent: 'Respuesta enviada exitosamente',
      replyFailed: 'Error al enviar respuesta',
      statusUpdated: 'Estado actualizado exitosamente',
      statusUpdateFailed: 'Error al actualizar estado',
      subject: 'Asunto',
      message: 'Mensaje',
      totalInventoryValue: 'Valor Total del Inventario',
      replied: 'Respondido',
      // Admin Panel - Vehicle Management (Spanish)
      available: 'Disponible',
      sold: 'Vendido',
      soldVehicles: 'vehículos vendidos',
      downloading: 'Descargando...',
      excel: 'Excel',
      filter: 'Filtrar',
      advancedFilters: 'Filtros Avanzados',
      clear: 'Limpiar',
      statusLabel: 'Estado',
      brandLabel: 'Marca',
      minPrice: 'Precio Mín',
      maxPrice: 'Precio Máx',
      minYear: 'Año Mín',
      maxYear: 'Año Máx',
      showDuplicateVins: 'Mostrar VINs Duplicados',
      allItems: 'Todos',
      vehiclesSelected: 'vehículos seleccionados',
      markAvailable: 'Marcar Disponible',
      markSold: 'Marcar Vendido',
      featureVehicle: 'Destacar',
      cancel: 'Cancelar',
      reactivate: 'Reactivar',
      syncCompleted: '¡Sincronización Completada!',
      syncNewAdded: 'nuevos vehículos agregados',
      syncMarkedSold: 'vehículos marcados como vendidos',
      syncVinConflicts: 'conflictos de VIN (revisión necesaria)',
      syncUnchanged: 'vehículos sin cambios',
      syncTotalEbay: 'Total de anuncios en eBay',
      syncCompletedUnclear: 'Sincronización completada pero resultado incierto',
      syncTimeoutMessage: 'Tiempo de espera: La sincronización puede seguir en curso. Actualice la página en unos minutos.',
      addAll: 'Agregar Todos',
      searchByVin: 'Buscar por VIN...',
      resultsFound: 'resultados encontrados',
      newBadge: 'NUEVO',
      reactivateTitle: 'Reactivar',
      markAsSoldTitle: 'Marcar como Vendido',
      selectAll: 'Seleccionar Todo',
      vehicleCount: 'vehículos',
      vinConflictsTitle: 'Conflictos de VIN',
      allSynced: 'Todos los vehículos se han sincronizado correctamente.',
      refresh: 'Actualizar',
      vinConflictWarning: 'Estos vehículos comparten el mismo VIN pero tienen diferente marca/modelo/año. Probablemente se reutilizó el VIN para un anuncio diferente en eBay. Revise cada conflicto y decida.',
      newListing: 'Nuevo Anuncio',
      addAsNewVehicle: 'Agregar como Nuevo Vehículo',
      skipConflict: 'Omitir',
      existingVehicle: 'Vehículo Existente',
      vinConflictsNote: 'Nota:',
      // Price Quote Actions (Spanish)
      approveQuote: 'Aprobar',
      rejectQuote: 'Rechazar',
      approve: 'Aprobar',
      reject: 'Rechazar',
      reply: 'Responder',
      quoteApproved: '¡Cotización aprobada! Cliente notificado.',
      quoteRejected: '¡Cotización rechazada! Cliente notificado.',
      operationFailed: 'Operación fallida',
      replySentSuccess: '¡Respuesta enviada! Email y notificación entregados.',
      priceQuoteResponse: 'Respuesta de Cotización',
      offeredPrice: 'Precio Ofrecido',
      replyWillBeSent: 'Su respuesta se enviará al cliente por email y notificación.',
      vehicleReactivated: '¡Vehículo reactivado!',
      vehicleMarkedSold: '¡Vehículo marcado como vendido!',
      makeAvailable: 'Marcar Disponible',
      markAsSold: 'Marcar Vendido',
      syncing: 'Sincronizando...',
      syncFromEbay: 'Sincronizar de eBay',
      all: 'Todos',
      brand: 'Marca',
      overview: 'Resumen',
      pendingTestDrives: 'Pruebas Pendientes',
      pendingQuotes: 'Cotizaciones Pendientes',
      monthlyActivity: 'Actividad Mensual',
      requestStatusDistribution: 'Distribución de Estado de Solicitudes',
      trendAnalysis: 'Análisis de Tendencias de 6 Meses',
      manageVehicles: 'Administrar Vehículos',
      totalActiveVehicles: 'vehículos activos',
      searchVehicles: 'Buscar por marca, modelo, año o precio...',
      vehicle: 'Vehículo',
      price: 'Precio',
      year: 'Año',
      mileage: 'Kilometraje',
      featured: 'Destacado',
      addVehicleBtn: 'Agregar Vehículo',
      updateVehicle: 'Actualizar Vehículo',
      deleteVehicle: 'Eliminar Vehículo',
      confirmDelete: '¿Estás seguro de que quieres eliminar',
      cannotUndo: 'Esta acción no se puede deshacer.',
      brand: 'Marca',
      model: 'Modelo',
      color: 'Color',
      vin: 'VIN',
      engine: 'Motor',
      transmission: 'Transmisión',
      fuelType: 'Tipo de Combustible',
      description: 'Descripción',
      features: 'Características (separadas por comas)',
      vehicleImages: 'Imágenes del Vehículo',
      uploadFromComputer: 'Subir desde Computadora',
      uploading: 'Subiendo imágenes...',
      uploadedImages: 'Imágenes Subidas:',
      orEnterUrls: 'O Ingresa URLs de Imágenes (separadas por comas)',
      featuredVehicle: 'Vehículo Destacado',
      rating: 'Calificación',
      review: 'Comentario',
      noReviewsFound: 'No se encontraron comentarios',
      reviewType: 'Tipo de Comentario',
      vehicleReviewType: 'Vehículo',
      generalReviewType: 'General',
      serviceReviewType: 'Servicio',
      dealershipReviewType: 'Concesionario',
      allReviews: 'Todos los Comentarios',
      testDrivesLabel: 'Pruebas de Manejo',
      priceQuotesLabel: 'Cotizaciones',
      messagesLabel: 'Mensajes',
      reviewsLabel: 'Reseñas',
      campaignsLabel: 'Campañas',
      analyticsLabel: 'Analíticas',
      performanceLabel: 'Rendimiento',
      usersLabel: 'Usuarios',
      scrollToSee: 'Desplázate para ver todas las columnas',
      dragToReorder: 'Arrastra para reordenar (primera imagen = principal)',
      suspiciousPhotosTab: 'Fotos Sospechosas',
      suspiciousPhotosTitle: 'Fotos Sospechosas (Escaneo IA)',
      suspiciousPhotosSub: 'La IA analiza cada foto buscando banners, anuncios e imágenes de vehículos equivocados.',
      startAIScan: 'Iniciar Escaneo IA',
      aiScanInProgress: 'Escaneo IA en progreso',
      scanStarted: 'Escaneo de fotos iniciado',
      scanFinished: 'Escaneo terminado',
      photosFlagged: 'fotos marcadas',
      photosScanned: 'fotos escaneadas',
      flagged: 'marcadas',
      highSeverity: 'Alta',
      mediumSeverity: 'Media',
      all: 'Todas',
      remove: 'Eliminar',
      keep: 'Mantener',
      viewVehicle: 'Ver vehículo',
      photoRemoved: 'Foto eliminada',
      photoKept: 'Foto mantenida',
      noSuspiciousPhotos: 'No se encontraron fotos sospechosas. Ejecuta un escaneo.',
      vinConflictHeading: 'Este VIN también se usa en otra publicación activa.',
      vinConflictShort: '¿Agregar la nueva como un registro separado?',
      vinConflictSameCar: 'Este vehículo ya está publicado. ¿Quieres agregarlo de nuevo?',
      vinConflictDifferentCar: 'Estos dos vehículos comparten el mismo VIN pero el año/kilometraje difieren — no son el mismo auto.',
      addAllDifferent: 'Agregar Vehículos Diferentes',
      addAllDifferentTooltip: 'Agrega todos los conflictos donde los autos son claramente diferentes a pesar de compartir VIN',
      noDifferentCars: 'No hay conflictos de "auto diferente" para agregar',
      vinConflictBody: 'La nueva publicación tiene el mismo VIN que un vehículo ya publicado en tu sitio. ¿Quieres agregar esta nueva publicación? "Agregar" crea un segundo registro (ambas se mostrarán). "Omitir" descarta la nueva. En ambos casos, la publicación existente no se altera.',
      enhance: 'Foto IA',
      enhanceAllPhotos: 'Mover Fotos al Showroom',
      enhanceAllTooltip: 'Reemplaza el fondo de todas las fotos con el showroom AAA OF MIAMI (IA)',
      enhancePhotosTooltip: 'Mueve las fotos de este vehículo al fondo del showroom (IA)',
      enhancingPhotos: 'Procesando fotos...',
      photosEnhanced: 'fotos procesadas',
      processing: 'Procesando...',
      restore: 'Restaurar',
      restoreOriginalsTooltip: 'Restaurar fotos originales',
      originalsRestored: 'Fotos originales restauradas',
      batchEnhanceStarted: 'Procesamiento por lotes iniciado. Ejecutándose en segundo plano.',
      batchEnhanceProgress: 'Procesamiento de fotos en progreso',
      vehiclesProcessed: 'vehículos procesados',
      sendReply: 'Enviar Respuesta',
      cancel: 'Cancelar',
      totalInquiries: 'Total de Consultas',
      vehiclesSold: 'Vehículos Vendidos',
      completedRequests: 'Completado',
      vehiclesUnit: 'vehículos',
      analytics: 'Analíticas',
      totalVisits: 'Visitas Totales',
      uniqueVisitors: 'Visitantes Únicos',
      todayVisits: 'Visitas de Hoy',
      avgPageViews: 'Páginas Vistas Promedio',
      trafficSources: 'Fuentes de Tráfico',
      direct: 'Directo',
      google: 'Google',
      socialMedia: 'Redes Sociales',
      other: 'Otros',
      popularPages: 'Páginas Más Populares',
      visits: 'Visitas',
      weeklyTrend: 'Tendencia de 7 Días',
      dailyVisits: 'Visitas Diarias',
      detailedReferrers: 'Fuentes de Tráfico Detalladas',
      referrer: 'Fuente',
      users: 'Usuarios',
      members: 'Miembros',
      totalMembers: 'Total de Miembros',
      adminUsers: 'Usuarios Admin',
      regularUsers: 'Usuarios Regulares',
      last7Days: 'Últimos 7 Días',
      searchPlaceholder: 'Buscar por email o nombre de usuario...',
      username: 'Nombre de Usuario',
      email: 'Correo Electrónico',
      role: 'Rol',
      registrationDate: 'Fecha de Registro',
      noUsersFound: 'No se encontraron usuarios',
      admin: 'Admin',
      user: 'Usuario',
      removeAdmin: 'Remover Admin',
      makeAdmin: 'Hacer Admin',
      deleteUser: 'Eliminar Usuario',
      deleteUserConfirm: '¿Estás seguro de que quieres eliminar a',
      deleteUserWarning: 'Esta acción no se puede deshacer.',
      cancel: 'Cancelar',
      yesDelete: 'Sí, Eliminar',
      userDeletedSuccess: 'Usuario eliminado exitosamente',
      userDeleteFailed: 'Error al eliminar usuario',
      adminGranted: 'Usuario promovido a admin',
      adminRevoked: 'Privilegios de admin revocados',
      operationFailed: 'Operación fallida',
      usersLoadFailed: 'Error al cargar usuarios',
      loading: 'Cargando...',
      emailMarketing: 'Marketing por Correo',
      emailCampaigns: 'Campañas de Correo',
      priceDropAlert: 'Alerta de Rebaja',
      newCampaign: 'Nueva Campaña',
      manageCampaigns: 'Administrar campañas y enviar correos promocionales',
      totalCampaigns: 'Total de Campañas',
      sentCampaigns: 'Enviadas',
      totalUsers: 'Total de Usuarios',
      optedInUsers: 'Suscritos',
      sendPriceDropAlert: 'Enviar Alerta de Rebaja',
      selectVehicle: 'Seleccionar Vehículo',
      chooseVehicle: 'Elige un vehículo',
      oldPrice: 'Precio Anterior',
      currentPrice: 'Precio actual',
      newPrice: 'Precio Nuevo',
      discountedPrice: 'Precio con descuento',
      discount: 'Descuento',
      saveAmount: 'Ahorra',
      sendToAllUsers: 'Enviar a Todos los Usuarios',
      createEmailCampaign: 'Crear Campaña de Correo',
      campaignTitle: 'Título de Campaña',
      internalCampaignName: 'Nombre interno para esta campaña',
      emailSubject: 'Asunto del Correo',
      inboxSubject: 'Lo que los usuarios verán en su bandeja',
      emailMessage: 'Mensaje',
      emailContent: 'Contenido del correo (soporta HTML)',
      campaignType: 'Tipo de Campaña',
      general: 'General',
      promotional: 'Promocional',
      newsletter: 'Boletín',
      targetAudience: 'Público Objetivo',
      allUsers: 'Todos los Usuarios',
      optedInOnly: 'Solo Suscritos',
      createCampaign: 'Crear Campaña',
      noCampaignsYet: '¡Aún no hay campañas! Crea tu primera campaña.',
      sent: 'Enviada',
      draft: 'Borrador',
      sentToUsers: 'Enviado a {count} usuarios el {date}',
      sendNow: 'Enviar Ahora',
      sending: 'Enviando...',
      priceDropHistory: 'Historial de Alertas de Rebaja',
      noPriceDropAlerts: 'No se han enviado alertas de rebaja aún',
      campaignSentSuccess: '¡Campaña enviada a {count} usuarios!',
      priceDropSentSuccess: '¡Alerta de rebaja enviada a {count} usuarios!',
      campaignCreatedSuccess: '¡Campaña creada exitosamente!',
      failedToLoad: 'Error al cargar datos de campañas',
      failedToSend: 'Error al enviar campaña',
      failedToCreate: 'Error al crear campaña',
      vehicleId: 'ID del Vehículo',
      usersCount: 'usuarios'
    },
    perf: {
      title: 'Panel de Rendimiento',
      subtitle: 'Métricas clave e información sobre tu concesionaria',
      loadFailed: 'Error al cargar estadísticas',
      noData: 'No hay datos disponibles',
      exportExcel: 'Exportar Excel',
      exporting: 'Exportando...',
      totalVehicles: 'Total de Vehículos',
      available: 'Disponibles',
      sold: 'Vendidos',
      totalSoldValue: 'Valor Total Vendido',
      avgPrice: 'Precio Promedio',
      customerEngagement: 'Interacción del Cliente',
      testDriveRequests: 'Solicitudes de Prueba',
      pendingTestDrives: 'Pruebas Pendientes',
      priceQuotes: 'Solicitudes de Cotización',
      pendingQuotes: 'Cotizaciones Pendientes',
      pricingStats: 'Estadísticas de Precios',
      minPrice: 'Precio Mínimo',
      maxPrice: 'Precio Máximo',
      featuredVehicles: 'Vehículos Destacados',
      mostViewed: 'Vehículos Más Vistos',
      mostFavorited: 'Vehículos Más Favoritos'
    },
    common: {
      loading: 'Cargando...',
      loadMore: 'Cargar Más',
      save: 'Guardar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      edit: 'Editar',
      close: 'Cerrar',
      yes: 'Sí',
      no: 'No',
      confirm: 'Confirmar',
      backToInventory: 'Volver al Inventario',
      noVehicles: 'No hay vehículos para comparar',
      addVehicles: 'Agrega vehículos del inventario para compararlos',
      browseInventory: 'Ver Inventario',
      clearAll: 'Limpiar Todo',
      compareTitle: 'Comparar Vehículos',
      compareSub: 'Compara hasta 3 vehículos lado a lado',
      noFavorites: 'No hay vehículos favoritos aún',
      sendMessage: 'Envíanos un mensaje',
      visitUs: 'Visítanos',
      address: 'Dirección',
      businessHours: 'Horario de Atención',
      getTouchTeam: 'Ponte en contacto con nuestro equipo',
      yourSavedVehicles: 'Tus vehículos guardados',
      vehicleNotFound: 'Vehículo no encontrado',
      backToInventoryBtn: 'Volver al Inventario',
      all: 'Todos',
      jan: 'Ene',
      feb: 'Feb',
      mar: 'Mar',
      apr: 'Abr',
      may: 'May',
      jun: 'Jun',
      january: 'Enero',
      february: 'Febrero',
      march: 'Marzo',
      april: 'Abril',
      june: 'Junio'
    },
    compare: {
      removedFromComparison: 'Eliminado de la comparación',
      comparisonCleared: 'Comparación limpiada'
    },
    compareBar: {
      compareNow: 'Comparar Ahora'
    },
    favorites: {
      noFavorites: 'No hay vehículos favoritos aún',
      browseInventory: 'Ver Inventario'
    },
    vehicleDetail: {
      loginToFavorite: 'Por favor inicia sesión para agregar favoritos',
      removedFromFavorites: 'Eliminado de favoritos',
      addedToFavorites: 'Agregado a favoritos',
      failedToUpdate: 'Error al actualizar favoritos',
      maxThreeVehicles: 'Solo puedes comparar hasta 3 vehículos',
      alreadyInComparison: 'El vehículo ya está en la lista de comparación',
      addedToComparison: 'Agregado a la comparación'
    },
    contactPage: {
      sending: 'Enviando...',
      mondayFriday: 'Lunes - Viernes',
      mondayFridayHours: '9:00 AM - 7:00 PM',
      saturday: 'Sábado',
      saturdayHours: '10:00 AM - 6:00 PM',
      sunday: 'Domingo',
      sundayHours: '11:00 AM - 5:00 PM'
    },
    reviews: {
      title: 'Reseñas de Clientes',
      writeReview: 'Escribir Reseña',
      yourName: 'Tu Nombre',
      yourEmail: 'Tu Email',
      yourRating: 'Tu Calificación',
      yourReview: 'Tu Reseña',
      submitReview: 'Enviar Reseña',
      reviewSubmitted: '¡Reseña enviada! Aparecerá después de la aprobación.',
      reviewFailed: 'Error al enviar reseña',
      noReviews: 'No hay reseñas aún',
      beFirst: '¡Sé el primero en reseñar este vehículo!',
      stars: 'estrellas',
      generalReview: 'Reseña General',
      writeGeneralReview: 'Escribir Reseña General',
      aboutOurService: 'Comparte tu experiencia con nuestro concesionario',
      generalReviewSubmitted: '¡Gracias por tu opinión!',
      reviewType: 'Tipo de Reseña',
      vehicleReview: 'Reseña de Vehículo',
      serviceReview: 'Servicio y Experiencia',
      dealershipReview: 'Reseña del Concesionario'
    },
    login: {
      title: 'Bienvenido a AAA OF MIAMI',
      subtitle: 'Inicia sesión para guardar favoritos y gestionar tus solicitudes',
      signIn: 'Iniciar Sesión',
      signUp: 'Registrarse',
      username: 'Nombre de Usuario',
      email: 'Correo Electrónico',
      password: 'Contraseña',
      confirmPassword: 'Confirmar Contraseña',
      enterUsername: 'Ingresa tu nombre de usuario',
      enterEmail: 'tu@correo.com',
      enterPassword: 'Ingresa tu contraseña',
      minChars: 'Mínimo 6 caracteres',
      reenterPassword: 'Vuelve a ingresar tu contraseña',
      signingIn: 'Iniciando sesión...',
      creatingAccount: 'Creando cuenta...',
      createAccount: 'Crear Cuenta',
      continueAsGuest: 'Continuar como Invitado',
      memberBenefits: 'Beneficios de Miembro:',
      saveFavorites: 'Guarda tus vehículos favoritos',
      compareVehicles: 'Compara vehículos lado a lado',
      forgotPassword: '¿Olvidaste tu contraseña?'
    },
    profile: {
      myProfile: 'Mi Perfil',
      username: 'Nombre de Usuario',
      email: 'Correo Electrónico',
      membershipType: 'Tipo de Membresía',
      admin: 'Administrador',
      standardUser: 'Usuario Estándar',
      changePassword: 'Cambiar Contraseña',
      currentPassword: 'Contraseña Actual',
      newPassword: 'Nueva Contraseña',
      confirmNewPassword: 'Confirmar Nueva Contraseña',
      enterCurrentPassword: 'Ingresa tu contraseña actual',
      enterNewPassword: 'Ingresa tu nueva contraseña',
      reenterNewPassword: 'Vuelve a ingresar tu nueva contraseña',
      passwordChanged: '¡Contraseña cambiada exitosamente!',
      passwordChangeFailed: 'Error al cambiar contraseña',
      passwordsDoNotMatch: 'Las nuevas contraseñas no coinciden',
      passwordTooShort: 'La nueva contraseña debe tener al menos 6 caracteres',
      cancel: 'Cancelar',
      logout: 'Cerrar Sesión',
      changing: 'Cambiando...',
      changePasswordButton: 'Cambiar Contraseña'
    },
    messages: {
      myMessages: 'Mis Mensajes',
      noMessages: 'No hay mensajes aún',
      sendMessage: 'Enviar Mensaje',
      messageSent: '¡Mensaje enviado! Puedes rastrearlo en la sección "Mis Mensajes".',
      messageFailed: 'Error al enviar mensaje',
      loadError: 'Error al cargar mensajes',
      pleaseWriteMessage: 'Por favor escribe un mensaje',
      replyLabel: 'Responder:',
      send: 'Enviar',
      sending: 'Enviando...',
      sendToSeller: 'Mensaje al Vendedor',
      messageFailedRetry: 'Error al enviar mensaje. Por favor intenta de nuevo.',
      yourInitialMessage: 'Tu Mensaje Inicial:',
      you: 'Tú',
      messageSeller: 'Mensaje al Vendedor',
      writeYourMessage: 'Escribe tu mensaje aquí...',
      writeYourReply: 'Escribe tu respuesta al cliente...',
      loginRequired: 'Necesitas iniciar sesión para enviar un mensaje'
    },
    forgotPassword: {
      title: 'Olvidé mi Contraseña',
      subtitle: 'Ingresa tu correo electrónico, te enviaremos un enlace para restablecer tu contraseña',
      emailPlaceholder: 'Tu correo electrónico',
      sendResetLink: 'Enviar Enlace de Restablecimiento',
      sending: 'Enviando...',
      linkSent: 'Si el correo existe, se ha enviado un enlace de restablecimiento',
      checkEmail: 'Por favor revisa tu bandeja de entrada.',
      backToLogin: 'Volver al Inicio de Sesión',
      resetSuccess: 'Enlace de restablecimiento de contraseña enviado a tu correo'
    },
    resetPassword: {
      title: 'Establecer Nueva Contraseña',
      subtitle: 'Ingresa tu nueva contraseña',
      newPassword: 'Nueva contraseña',
      confirmPassword: 'Confirmar nueva contraseña',
      changePassword: 'Cambiar Contraseña',
      changing: 'Cambiando...',
      passwordChanged: '¡Contraseña cambiada exitosamente!',
      invalidLink: 'Enlace Inválido',
      linkExpired: 'El enlace de restablecimiento de contraseña es inválido o ha expirado'
    },
    adminLogin: {
      title: 'PANEL ADMINISTRATIVO',
      subtitle: 'AAA OF MIAMI LLC',
      restrictedAccess: 'Acceso Restringido',
      description: 'Inicio de Sesión de Administrador',
      enterCredentials: 'Ingresa tus credenciales para acceder al panel administrativo',
      adminUsername: 'Usuario Administrador',
      enterAdminUsername: 'Ingresa usuario administrador',
      adminPassword: 'Contraseña Administrador',
      enterAdminPassword: 'Ingresa contraseña administrador',
      authenticating: 'Autenticando...',
      accessPanel: 'Acceder al Panel',
      needAccess: '¿Necesitas acceso de administrador?',
      registerAdmin: 'Registrar Cuenta Admin',
      backToSite: 'Volver al Sitio Principal',
      secureConnection: 'Conexión SSL segura',
      firstUserAdmin: 'El primer usuario registrado se convierte en administrador automáticamente',
      warning: 'Esta área está restringida solo para administradores autorizados. Los intentos de acceso no autorizados se registran.'
    }
  },

  tr: {
    admin: {
      dashboard: 'Panel',
      pleaseLogin: 'Lütfen giriş yapın',
      syncError: 'Senkronizasyon hatası',
      unknownError: 'Bilinmeyen hata',
      syncTimeout: 'Zaman aşımı: Senkronizasyon devam ediyor olabilir. Birkaç dakika sonra sayfayı yenileyin.',
      syncFailed: 'eBay senkronizasyonu başarısız',
      pleaseWriteReply: 'Lütfen bir yanıt yazın',
      vehicles: 'Araçlar',
      addVehicle: 'Araç Ekle',
      editVehicle: 'Araç Düzenle',
      testDrives: 'Test Sürüşü Talepleri',
      quotes: 'Fiyat Teklifi Talepleri',
      messages: 'İletişim Mesajları',
      reviews: 'Yorumlar',
      stats: 'İstatistikler',
      totalVehicles: 'Toplam Araç',
      pendingRequests: 'Bekleyen Talepler',
      newMessages: 'Yeni Mesajlar',
      adminPanel: 'Yönetim Paneli',
      status: 'Durum',
      pending: 'Bekliyor',
      approved: 'Onaylandı',
      rejected: 'Reddedildi',
      completed: 'Tamamlandı',
      approve: 'Onayla',
      reject: 'Reddet',
      reply: 'Yanıtla',
      viewDetails: 'Detayları Gör',
      customerName: 'Müşteri Adı',
      customerEmail: 'E-posta',
      customerPhone: 'Telefon',
      preferredDate: 'Tercih Edilen Tarih',
      preferredTime: 'Tercih Edilen Saat',
      requestDate: 'Talep Tarihi',
      actions: 'İşlemler',
      noRequests: 'Talep bulunamadı',
      sendReply: 'Yanıt Gönder',
      replyMessage: 'Yanıt Mesajı',
      typeReply: 'Yanıtınızı buraya yazın...',
      replySent: 'Yanıt başarıyla gönderildi',
      replyFailed: 'Yanıt gönderilemedi',
      statusUpdated: 'Durum güncellendi',
      statusUpdateFailed: 'Durum güncellenemedi',
      subject: 'Konu',
      message: 'Mesaj',
      totalInventoryValue: 'Toplam Envanter Değeri',
      replied: 'Yanıtlandı',
      available: 'Mevcut',
      sold: 'Satıldı',
      soldVehicles: 'satılan araçlar',
      downloading: 'İndiriliyor...',
      excel: 'Excel',
      filter: 'Filtrele',
      advancedFilters: 'Gelişmiş Filtreler',
      clear: 'Temizle',
      statusLabel: 'Durum',
      brandLabel: 'Marka',
      minPrice: 'Min Fiyat',
      maxPrice: 'Max Fiyat',
      minYear: 'Min Yıl',
      maxYear: 'Max Yıl',
      showDuplicateVins: 'Aynı VIN\'li Araçları Göster',
      allItems: 'Tümü',
      vehiclesSelected: 'araç seçildi',
      markAvailable: 'Mevcut Yap',
      markSold: 'Satıldı Yap',
      featureVehicle: 'Öne Çıkar',
      cancel: 'İptal',
      reactivate: 'Tekrar Aktif Et',
      syncCompleted: 'Senkronizasyon Tamamlandı!',
      syncNewAdded: 'yeni araç eklendi',
      syncMarkedSold: 'araç satıldı olarak işaretlendi',
      syncVinConflicts: 'VIN çakışması (inceleme gerekli)',
      syncUnchanged: 'araç değişmeden kaldı',
      syncTotalEbay: 'Toplam eBay ilanı',
      syncCompletedUnclear: 'Senkronizasyon tamamlandı ama sonuç belirsiz',
      syncTimeoutMessage: 'Zaman aşımı: Senkronizasyon devam ediyor olabilir. Birkaç dakika sonra yenileyin.',
      addAll: 'Tümünü Ekle',
      searchByVin: 'VIN ile Ara...',
      resultsFound: 'sonuç bulundu',
      newBadge: 'YENİ',
      reactivateTitle: 'Tekrar Aktif Et',
      markAsSoldTitle: 'Satıldı Olarak İşaretle',
      selectAll: 'Tümünü Seç',
      vehicleCount: 'araç',
      vinConflictsTitle: 'VIN Çakışmaları',
      allSynced: 'Tüm araçlar doğru şekilde senkronize edilmiş.',
      refresh: 'Yenile',
      vinConflictWarning: 'Bu araçlar aynı VIN numarasına sahip ama farklı marka/model/yıl bilgilerine sahip. Muhtemelen eBay\'de VIN değiştirilmeden farklı bir araç listelenmiş. Her çakışmayı inceleyip karar verin.',
      newListing: 'Yeni İlan',
      addAsNewVehicle: 'Yeni Araç Olarak Ekle',
      skipConflict: 'Atla',
      existingVehicle: 'Mevcut Kayıt',
      vinConflictsNote: 'Dikkat:',
      approveQuote: 'Onayla',
      rejectQuote: 'Reddet',
      quoteApproved: 'Teklif onaylandı! Müşteri bilgilendirildi.',
      quoteRejected: 'Teklif reddedildi! Müşteri bilgilendirildi.',
      operationFailed: 'İşlem başarısız',
      replySentSuccess: 'Yanıt gönderildi! E-posta ve bildirim iletildi.',
      priceQuoteResponse: 'Fiyat Teklifi Yanıtı',
      offeredPrice: 'Teklif Edilen Fiyat',
      replyWillBeSent: 'Yanıtınız müşteriye e-posta ve bildirim ile gönderilecek.',
      vehicleReactivated: 'Araç tekrar aktif edildi!',
      vehicleMarkedSold: 'Araç satıldı olarak işaretlendi!',
      makeAvailable: 'Mevcut Yap',
      markAsSold: 'Satıldı Yap',
      syncing: 'Senkronize ediliyor...',
      syncFromEbay: 'eBay\'den Senkronize Et',
      all: 'Tümü',
      brand: 'Marka',
      overview: 'Genel Bakış',
      pendingTestDrives: 'Bekleyen Test Sürüşleri',
      pendingQuotes: 'Bekleyen Teklifler',
      monthlyActivity: 'Aylık Aktivite',
      requestStatusDistribution: 'Talep Durumu Dağılımı',
      trendAnalysis: '6 Aylık Trend Analizi',
      manageVehicles: 'Araç Yönetimi',
      totalActiveVehicles: 'aktif araçlar',
      searchVehicles: 'Marka, model, yıl veya fiyat ile ara...',
      vehicle: 'Araç',
      price: 'Fiyat',
      year: 'Yıl',
      mileage: 'Kilometre',
      featured: 'Öne Çıkan',
      addVehicleBtn: 'Araç Ekle',
      updateVehicle: 'Araç Güncelle',
      deleteVehicle: 'Araç Sil',
      confirmDelete: 'Silmek istediğinize emin misiniz:',
      cannotUndo: 'Bu işlem geri alınamaz.',
      model: 'Model',
      color: 'Renk',
      vin: 'VIN',
      engine: 'Motor',
      transmission: 'Şanzıman',
      fuelType: 'Yakıt Tipi',
      description: 'Açıklama',
      features: 'Özellikler (virgülle ayırın)',
      vehicleImages: 'Araç Fotoğrafları',
      uploadFromComputer: 'Bilgisayardan Yükle',
      uploading: 'Fotoğraflar yükleniyor...',
      uploadedImages: 'Yüklenen Fotoğraflar:',
      orEnterUrls: 'Veya Fotoğraf URL\'leri Girin (virgülle ayırın)',
      featuredVehicle: 'Öne Çıkan Araç',
      rating: 'Puan',
      review: 'Yorum',
      noReviewsFound: 'Yorum bulunamadı',
      reviewType: 'Yorum Tipi',
      vehicleReviewType: 'Araç',
      generalReviewType: 'Genel',
      serviceReviewType: 'Servis',
      dealershipReviewType: 'Bayi',
      allReviews: 'Tüm Yorumlar',
      testDrivesLabel: 'Test Sürüşleri',
      priceQuotesLabel: 'Fiyat Teklifleri',
      messagesLabel: 'Mesajlar',
      reviewsLabel: 'Yorumlar',
      campaignsLabel: 'Kampanyalar',
      analyticsLabel: 'Analitik',
      performanceLabel: 'Performans',
      usersLabel: 'Kullanıcılar',
      analytics: 'Analitik',
      totalVisits: 'Toplam Ziyaret',
      uniqueVisitors: 'Tekil Ziyaretçi',
      todayVisits: 'Bugünkü Ziyaretler',
      avgPageViews: 'Ort. Sayfa Görüntüleme',
      trafficSources: 'Trafik Kaynakları',
      direct: 'Doğrudan',
      google: 'Google',
      socialMedia: 'Sosyal Medya',
      other: 'Diğer',
      popularPages: 'En Popüler Sayfalar',
      visits: 'Ziyaretler',
      weeklyTrend: '7 Günlük Trend',
      dailyVisits: 'Günlük Ziyaretler',
      detailedReferrers: 'Detaylı Trafik Kaynakları',
      referrer: 'Kaynak',
      scrollToSee: 'Tüm sütunları görmek için kaydırın',
      dragToReorder: 'Sıralamak için sürükleyin (ilk fotoğraf = ana görsel)',
      suspiciousPhotosTab: 'Şüpheli Fotoğraflar',
      suspiciousPhotosTitle: 'Şüpheli Fotoğraflar (AI Tarama)',
      suspiciousPhotosSub: 'AI her araç fotoğrafını tarar; reklam, banner ve yanlış araç görsellerini bulur.',
      startAIScan: 'AI Taramayı Başlat',
      aiScanInProgress: 'AI tarama sürüyor',
      scanStarted: 'Fotoğraf taraması başlatıldı',
      scanFinished: 'Tarama tamamlandı',
      photosFlagged: 'fotoğraf işaretlendi',
      photosScanned: 'fotoğraf tarandı',
      flagged: 'işaretlendi',
      highSeverity: 'Yüksek',
      mediumSeverity: 'Orta',
      all: 'Tümü',
      remove: 'Sil',
      keep: 'Koru',
      viewVehicle: 'Aracı Görüntüle',
      photoRemoved: 'Fotoğraf silindi',
      photoKept: 'Fotoğraf korundu',
      noSuspiciousPhotos: 'Şüpheli fotoğraf bulunamadı. Tarama başlatın.',
      vinConflictHeading: 'Bu VIN numarası başka bir aktif ilanda da kullanılıyor.',
      vinConflictShort: 'Yeni ilanı ayrı bir kayıt olarak eklemek ister misin?',
      vinConflictSameCar: 'Bu araç zaten ilanda var. Tekrar koymak ister misin?',
      vinConflictDifferentCar: "Bu araç aynı VIN'i kullanıyor ama yıl/mileage farklı — yani aynı araç değil.",
      addAllDifferent: 'Farklı Araçları Ekle',
      addAllDifferentTooltip: 'Aynı VIN kullanan ama gerçekte farklı olan araçların hepsini ekle',
      noDifferentCars: 'Eklenecek "farklı araç" bulunamadı',
      vinConflictBody: 'Aşağıdaki yeni ilanın VIN numarası, sitende zaten yayında olan başka bir araçla aynı. Bu yeni ilanı eklemek ister misin? "Ekle" dersen ikinci ilan ayrı bir kayıt olarak yayına girer (her iki ilan da görünür). "Atla" dersen sadece mevcut ilan kalır, yeni ilan kayıt edilmez. Her iki seçenek de mevcut ilanına dokunmaz.',
      activate: 'Aktif Et',
      importCSV: 'CSV İçe Aktar',
      noVehiclesFound: 'Araç bulunamadı',
      delete: 'Sil',
      save: 'Kaydet',
      close: 'Kapat',
      yes: 'Evet',
      no: 'Hayır',
      loading: 'Yükleniyor...',
      error: 'Hata',
      success: 'Başarılı',
      bulkActions: 'Toplu İşlemler',
      deleteSelected: 'Seçilenleri Sil',
      enhance: 'AI Foto',
      enhanceAllPhotos: 'Fotoğrafları Showroom\'a Taşı',
      enhanceAllTooltip: 'Tüm araç fotoğraflarının arkaplanını AAA OF MIAMI showroom ile değiştir (AI)',
      enhancePhotosTooltip: 'Bu aracın fotoğraflarını AI ile showroom arkaplanına taşı',
      enhancingPhotos: 'Fotoğraflar işleniyor...',
      photosEnhanced: 'fotoğraf işlendi',
      processing: 'İşleniyor...',
      restore: 'Geri Al',
      restoreOriginalsTooltip: 'Orijinal fotoğraflara geri dön',
      originalsRestored: 'Orijinal fotoğraflar geri yüklendi',
      batchEnhanceStarted: 'Toplu fotoğraf işleme başlatıldı. Arka planda çalışıyor.',
      batchEnhanceProgress: 'Fotoğraf işleme devam ediyor',
      vehiclesProcessed: 'araç işlendi'
    },
    perf: {
      title: 'Performans Paneli',
      subtitle: 'Bayiniz hakkında önemli metrikler ve analizler',
      loadFailed: 'İstatistikler yüklenemedi',
      noData: 'Veri bulunamadı',
      exportExcel: 'Excel İndir',
      exporting: 'İndiriliyor...',
      totalVehicles: 'Toplam Araç',
      available: 'Mevcut',
      sold: 'Satılmış',
      totalSoldValue: 'Toplam Satış Değeri',
      avgPrice: 'Ortalama Fiyat',
      customerEngagement: 'Müşteri Etkileşimi',
      testDriveRequests: 'Test Sürüşü Talepleri',
      pendingTestDrives: 'Bekleyen Test Sürüşleri',
      priceQuotes: 'Fiyat Teklifi Talepleri',
      pendingQuotes: 'Bekleyen Teklifler',
      pricingStats: 'Fiyat İstatistikleri',
      minPrice: 'Minimum Fiyat',
      maxPrice: 'Maksimum Fiyat',
      featuredVehicles: 'Öne Çıkan Araçlar',
      mostViewed: 'En Çok Görüntülenen Araçlar',
      mostFavorited: 'En Çok Favorilenen Araçlar'
    },
    common: {
      clearAll: 'Tümünü Temizle',
      backToInventory: 'Envantere Dön',
      loading: 'Yükleniyor...',
      loadMore: 'Daha Fazla Yükle'
    },
    nav: {
      compare: 'Karşılaştır'
    },
    compare: {
      removedFromComparison: 'Karşılaştırmadan çıkarıldı',
      comparisonCleared: 'Karşılaştırma temizlendi'
    },
    vehicleDetail: {
      maxThreeVehicles: 'En fazla 3 aracı karşılaştırabilirsiniz',
      alreadyInComparison: 'Araç zaten karşılaştırma listesinde',
      addedToComparison: 'Karşılaştırmaya eklendi'
    },
    compareBar: {
      compareNow: 'Karşılaştır'
    }
  }
};

export const useTranslation = (lang = 'en') => {
  const t = (key) => {
    const keys = key.split('.');
    let value = translations[lang];
    for (const k of keys) {
      value = value?.[k];
    }
    if (value !== undefined && value !== null) return value;

    // Fallback to English if locale key is missing
    if (lang !== 'en') {
      let en = translations.en;
      for (const k of keys) {
        en = en?.[k];
      }
      if (en !== undefined && en !== null) return en;
    }

    return key;
  };

  return { t };
};

export default translations;
